// extracted by mini-css-extract-plugin
export var marginNegative = "_6t-5 _6t-3 _6t-1";
export var marginPositive = "_6t-4 _6t-3 _6t-1";
export var modalContent = "_6t-6";
export var samplesTable = "_6t-8";
export var samplesTableContainer = "_6t-7";
export var statBox = "_6t-a";
export var tableCell = "_6t-1";
export var tableCellCenter = "_6t-2 _6t-1";
export var tableCellRight = "_6t-3 _6t-1";
export var tableHeader = "_6t-0";
export var trackingNumber = "_6t-9";